/**
 * Microsoft Graph / SharePoint settings for the Word add-in.
 * // TODO: Replace placeholder site id with VITE_GRAPH_SITE_ID from deployment env (see Azure / backend team).
 */

const trim = (v: string | undefined): string | null => {
  const t = v?.trim();
  return t && t.length > 0 ? t : null;
};

/** Graph API v1.0 base URL */
export const GRAPH_API_BASE = "https://graph.microsoft.com/v1.0";

/**
 * Site identifier for Graph `GET /sites/{site-id}/...`.
 * Prefer full Graph site id; hostname:path form is also accepted by Graph.
 */
export function getGraphSiteId(): string | null {
  return trim(import.meta.env.VITE_GRAPH_SITE_ID as string | undefined);
}

/**
 * When true, Template Library loads `.docx` rows from Graph (`listFiles`) instead of the templates API.
 * Requires `getGraphSiteId()` and successful token exchange.
 */
export function useGraphTemplateLibrary(): boolean {
  return import.meta.env.VITE_GRAPH_TEMPLATE_LIBRARY === "true";
}

/**
 * Default Microsoft Graph `driveId` for `PUT .../drives/{driveId}/items/{itemId}/content`
 * when the commit API omits `graph_drive_id` but a single document library is configured.
 * // TODO: Align with operations / Azure (same drive as generated-contract v2 draft uploads).
 */
export function getDefaultGraphDriveId(): string | null {
  return trim(import.meta.env.VITE_SHAREPOINT_DRIVE_ID as string | undefined);
}
